import React from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, FormControl, FormHelperText, InputLabel, OutlinedInput, Typography, Modal, Stack, IconButton } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// colors
import colors from 'assets/scss/_themes-vars.module.scss';

// propTypes
import propTypes from 'prop-types';

// spices
import { Spice } from '@qubiteq/qublib';

// apis
import { auth } from 'apis';

import { useSnackbar } from 'notistack';
// icons
import { IconLock, IconX } from '@tabler/icons';

const ForgotPasswordModal = React.memo(({ open = false, toggle }) => {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const Form = () => (
        <Formik
            initialValues={{
                email: ''
            }}
            validationSchema={Yup.object().shape({
                email: Yup.string().max(255).required('Email is required').email()
            })}
            onSubmit={async (values) => {
                try {
                    await auth.resetPasswordEmail(values);
                    enqueueSnackbar('Στάλθηκε email για την επαναφορά του κωδικού', {
                        variant: 'success'
                    });
                    toggle();
                } catch (error) {
                    console.log('error', error);
                    if (error?.data?.type === 400) {
                        enqueueSnackbar('Στάλθηκε email για την επαναφορά του κωδικού', {
                            variant: 'success'
                        });
                    } else {
                        enqueueSnackbar('Κάτι πήγε λάθος, προσπαθήστε ξανά', {
                            variant: 'error'
                        });
                    }
                    toggle();
                    console.log('error', error);
                }
            }}
        >
            {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                <form noValidate onSubmit={handleSubmit}>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            color: colors.grey700
                        }}
                    >
                        Το email σας
                    </Typography>
                    <FormControl fullWidth error={Boolean(touched.email && errors.email)} sx={{ ...theme.typography.customInput }}>
                        <InputLabel htmlFor="outlined-adornment-username-login">Email</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-username-login"
                            type="email"
                            value={values.email}
                            name="email"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            label="Email Address"
                            inputProps={{}}
                        />
                        {touched.email && errors.email && (
                            <FormHelperText error id="standard-weight-helper-text-username-login">
                                {errors.email}
                            </FormHelperText>
                        )}
                    </FormControl>
                    <Box sx={{ mt: 2 }}>
                        <LoadingButton
                            disableElevation
                            disableRipple
                            loading={isSubmitting}
                            fullWidth
                            size="large"
                            type="submit"
                            variant="outlined"
                            color="primary"
                        >
                            ΕΠΑΝΑΦΟΡΑ ΚΩΔΙΚΟΥ ΠΡΟΣΒΑΣΗΣ
                        </LoadingButton>
                    </Box>
                </form>
            )}
        </Formik>
    );

    const Title = () => (
        <Stack spacing={4} direction="row">
            <Spice />
            <Typography variant="h2" color="primary">
                Ξέχασα τον κωδικό μου
            </Typography>
            <IconLock color={colors.primaryMain} strokeWidth={2.5} />
        </Stack>
    );

    return (
        <Modal open={open}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: colors.paper,
                    boxShadow: 24,
                    outline: 'none',
                    borderRadius: 2,
                    p: 0.5
                }}
            >
                <Stack alignItems="flex-end">
                    <IconButton sx={{ width: 50, height: 50 }} onClick={toggle}>
                        <IconX color={colors.primaryMain} />
                    </IconButton>
                </Stack>
                <Stack spacing={4} p={3}>
                    <Title />
                    <Form />
                </Stack>
            </Box>
        </Modal>
    );
});

ForgotPasswordModal.propTypes = {
    open: propTypes.bool,
    toggle: propTypes.func
};

export default ForgotPasswordModal;
